import JoinCard from "../components/JoinCard"

interface Props {
  /** Members we already knew from Artemis skip the waitlist and are texted right away. */
  approved: boolean
}

export default function DoneStep({ approved }: Props) {
  if (approved) {
    return (
      <JoinCard title="You're in" subtitle="We just texted you — no waitlist for you.">
        <p className="join-fine-print mt-0">Reply 1 to that message and we'll send over the app.</p>
      </JoinCard>
    )
  }

  return (
    <JoinCard
      title="You're on the waitlist"
      subtitle="We'll text you in 1-2 days with more information."
    >
      <p className="join-fine-print mt-0">Keep an eye out for a message from Apollo.</p>
    </JoinCard>
  )
}
